import { useMemo } from 'react';
import { IBudgetsListResponse } from '../../../../api/fetchBudget';
import { BudgetRecipientEnum, IBudgetFormData } from '../../createAndEdit/types';
import { useConsultantListJourney } from './journeys/useConsultantListJourney';
import { useFactoryListJourney } from './journeys/useFactoryListJourney';
import { useManagerListJourney } from './journeys/useManagerListJourney';

interface IUseListJourneySelectorParams {
  budgetsListResponse: IBudgetsListResponse | null | undefined;
  userProfile: BudgetRecipientEnum | undefined;
  onNavigateToView: (budgetId: string, data: IBudgetFormData) => void;
  onNavigateToEdit: (budgetId: string, data: IBudgetFormData) => void;
  loadBudgetData: (budgetId: string, versionNumber?: number) => Promise<IBudgetFormData | null>;
}

export const useListJourneySelector = (params: IUseListJourneySelectorParams) => {
  const { budgetsListResponse, userProfile, onNavigateToView, onNavigateToEdit, loadBudgetData } =
    params;

  const consultantJourney = useConsultantListJourney({
    budgetsListResponse,
    userProfile,
    onNavigateToView,
    onNavigateToEdit,
    loadBudgetData,
  });

  const factoryJourney = useFactoryListJourney({
    budgetsListResponse,
    userProfile,
    onNavigateToView,
    onNavigateToEdit,
    loadBudgetData,
  });

  const managerJourney = useManagerListJourney({
    budgetsListResponse,
    userProfile,
    onNavigateToView,
    onNavigateToEdit,
    loadBudgetData,
  });

  const activeJourney = useMemo(() => {
    switch (userProfile) {
      case BudgetRecipientEnum.CONSULTANT:
        return consultantJourney;
      case BudgetRecipientEnum.TOWER:
        return factoryJourney;
      case BudgetRecipientEnum.MANAGER:
        return managerJourney;
      default:
        return consultantJourney;
    }
  }, [userProfile, consultantJourney, factoryJourney, managerJourney]);

  return {
    activeJourney,
    handleViewOrEditBudget: activeJourney.handleViewOrEditBudget,
  };
};
